import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TransferService } from "./services/transfer.service";

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [TransferService]
})
export class TransferModule {}
